// reach_ui/src/components/VastGPT/ToolCallComponent.js
import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { Sms, Email } from '@material-ui/icons'
import Link from '../../utils/Link'
import newEmailHtmlFunc from '../../utils/newEmailHtmlFunc'
import Ellipsis from './Ellipsis'
import MarkdownWithEllipsis from './MarkdownWithEllipsis'

const ToolCallComponent = ({
  message,
  isLastMessage,
  loadingResponse,
  create,
  createTemplate,
}) => {
  const [createdLink, setCreatedLink] = useState(null)

  if (isLastMessage && loadingResponse) {
    return (
      <div>
        Loading
        <Ellipsis />
      </div>
    )
  }

  try {
    const func = message.tool_calls[0]?.function
    const entity = JSON.parse(func?.arguments)

    if (func?.name === 'create_sms_template') {
      return (
        <div>
          <div style={{ marginBottom: 10 }}>"{entity?.Template?.TextPart}"</div>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() =>
              create({ entityType: 'sms/template', entity }).then(payload => {
                setCreatedLink(
                  `${window.location.origin}/templates/sms/${payload?.id}`,
                )
              })
            }
          >
            <Sms style={{ marginRight: 5, marginTop: 2 }} />
            Create text template
          </Button>
          {createdLink && (
            <div style={{ marginTop: 10 }}>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={createdLink}
              >
                {createdLink}
              </Link>
            </div>
          )}
        </div>
      )
    } else if (func?.name === 'create_email_template') {
      return (
        <div>
          <div style={{ marginBottom: 10, fontWeight: 'bold' }}>Subject: {entity?.subject}</div>
          <div style={{ marginBottom: 10 }}>{entity ? <MarkdownWithEllipsis
                  markdown={entity.body}
                  loadingResponse={"loadingResponse"}
                /> : ""}</div>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => {
              console.log(entity)
              createTemplate({
                Template: {
                  SubjectPart: entity?.subject,
                  HtmlPart: newEmailHtmlFunc(entity?.body),
                  TextPart: '',
                },
                name: entity?.name,
                default_template_values: {
                  'AccountPreference.company_logo_bgcolor_color': '',
                  'AccountPreference.company_logo_url_color': '',
                  'AccountPreference.email_color_button_background': '',
                  'AccountPreference.email_color_button_text': '',
                  'AccountPreference.email_color_text_paragraph': '',
                },
              }).then(payload => {
                setCreatedLink(
                  `${window.location.origin}/templates/email/${payload?.id}`,
                )
              })
            }}
          >
            <Email style={{ marginRight: 5, marginTop: 2 }} />
            Create email template
          </Button>
          {createdLink && (
            <div style={{ marginTop: 10 }}>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href={createdLink}
              >
                {createdLink}
              </Link>
            </div>
          )}
        </div>
      )
    } else {
      return <div>Unknown function: {func?.name}</div>
    }
  } catch (error) {
    console.log(error)
    return <div>Processing Vast Reach tool call...</div>
  }
}

export default ToolCallComponent
